export const GET_DAILY_REPORT = "v6/stores/report/daily";
export const GET_ATU = "v6/stores/atu";